import { observable, action, decorate } from 'mobx'
import axios from 'axios'

class EditReinfStore {
  constructor (rootStore) {
    this.state = {
      id: '',
      data: {
        id: '',
        cliente: '',
        alias: '',
        ativo: true,
        dir_xml: '',
        email: '',
        downloads: []
      },
      isUpdating: false,
      modalIsActive: false
    }

    this.stores = rootStore.stores
  }

  openModal () {
    this.state.modalIsActive = true
  }

  closeModal () {
    this.state.modalIsActive = false
  }

  handleChange(value, name) {
    this.state.data[name] = value
  }

  toggleActive () {
    this.state.data.ativo = !this.state.data.ativo
  }

  setFormData (data, id) {
    this.state.id = id
    this.state.data.downloads = data.downloads
    this.state.data.cliente = data.cliente
    this.state.data.alias = data.alias
    this.state.data.ativo = data.ativo
    this.state.data.dir_xml = data.dir_xml
    this.state.data.email = data.email
  }

  updateReinfInformation () {
    this.state.isUpdating = true
    const url = process.env.REACT_APP_AWS_URL + '/updateCompanyProductInfo'
    axios.post(url, {
      id: this.state.id,
      product: '4REINF',
      data: this.state.data
    })
    .then(response => {
      this.state.isUpdating = false
      this.closeModal()
      this.stores.configCompaniesStore.fetchAllCompanies()
    })
    .catch(error => {
      this.state.isUpdating = false
    })
  }
}

decorate(EditReinfStore, {
  state: observable
})

export default EditReinfStore



// WEBPACK FOOTER //
// ./src/stores/config/companies/products/editReinfStore.js